import classNames from 'classnames';
import styles from './ClientCard.module.scss';

type ClientCardProps = {
  data?: any;
  onClick?: any;
  loading?: boolean;
};

function ClientCard({ data, onClick, loading }: ClientCardProps) {
  return (
    <div
      className={classNames(styles.container, {
        [styles.loading]: loading,
        [styles.disabled]: !data?.enabled,
      })}
      onClick={onClick}
    >
      <div className={styles.heading}>
        <div className={styles.abbreviation}>{data?.abbreviation}</div>
        <div className={styles.meta}>
          <div className={styles.publishDate}>
            ({new Date(data?.publishDate).toLocaleDateString('fa-IR')})
          </div>
          <div className={styles.version}>{data?.version}</div>
        </div>
      </div>
      <div className={styles.name}>{data?.name}</div>
    </div>
  );
}

export default ClientCard;
